export default __webpack_public_path__ + "static/media/X8000G6I.22f38e20.jpg";